export default __webpack_public_path__ + "static/media/walletIconFull.294e6b00.svg";